<template>
    <div>
        <v-layout>
            <v-flex xs4>
                <v-card-title>
                    <span class="title font-weight-light">{{ $t('form.project.label') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                            v-model="form.firebaseProject.timeZone"
                            :label="$t('form.timeZone')"
                    ></v-text-field>
                    <v-text-field
                            v-model="form.firebaseProject.regionCode"
                            :label="$t('form.regionCode')"
                    ></v-text-field>
                    <v-text-field
                            v-model="form.firebaseProject.locationId"
                            :label="$t('form.locationId')"
                    ></v-text-field>
                </v-card-text>
            </v-flex>
            <v-flex xs4>
                <v-card-title>
                    <v-icon>android</v-icon>&nbsp;
                    <span class="title font-weight-light">{{ $t('form.androidApp.label') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                            v-model="form.androidApp.packageName"
                            :label="$t('form.androidApp.packageName')"
                    ></v-text-field>
                    <v-text-field
                            v-model="form.androidApp.sha.sha"
                            :label="$t('form.androidApp.sha')"
                    ></v-text-field>
                </v-card-text>
            </v-flex>
            <v-flex xs4>
                <v-card-title>
                    <v-icon>phone_iphone</v-icon>&nbsp;
                    <span class="title font-weight-light">{{ $t('form.iosApp.label') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                            v-model="form.iosApp.bundleId"
                            :label="$t('form.iosApp.bundleId')"
                    ></v-text-field>
                </v-card-text>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-btn class="submit-btn" @click="submit">{{ $t('form.submit') }}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    export default {
        name: "SubmittedProjectDialog",
        props: {
          project: {
              type: Object,
              required: true,
          }
        },
        data() {
            return {
                form: {
                    firebaseProject: {
                        regionCode: 'US',
                        timeZone: 'America/New_York',
                        locationId: 'us-central',
                    },
                    androidApp: {
                        type: 'android',
                        packageName: '',
                        sha: {
                            type: 'SHA_1',
                            sha: ''
                        },
                    },
                    iosApp: {
                        type: 'ios',
                        bundleId: ''
                    }
                }
            }
        },
        methods: {
            submit() {
                this.$emit('submitted', this.form);
            },
            clear() {
                this.form = {
                    firebaseProject: {
                        regionCode: 'US',
                        timeZone: 'America/New_York',
                        locationId: 'us-central',
                    },
                    androidApp: {
                        type: 'android',
                        packageName: '',
                        sha: {
                            type: 'SHA_1',
                            sha: ''
                        },
                    },
                    iosApp: {
                        type: 'ios',
                        bundleId: ''
                    }
                };
            },
        }
    }
</script>

<style scoped>

</style>
